import TNavDropdown from "./TNavDropdown.vue";

export default TNavDropdown;
